import { HeaderData } from '@bm-js/atlascloud-shared'
import { useMemo } from 'react'
import { useMargin } from '../utils/hooks'
import { CText } from './CText'
import {
  fontSizes,
  fontWeights,
  leadings,
  maxWidths,
  textAligns,
  textColors,
} from '../utils/typography'

type Props = {
  content: {
    data: HeaderData
  }
}

export const HeaderContent = ({ content }: Props) => {
  const textClasses = useMemo(() => {
    const fontSize = fontSizes[content.data.fontSize]
    const fontWeight = fontWeights[content.data.fontWeight] || 'font-bold'
    const textAlign = textAligns[content.data.alignment]
    const color = textColors[content.data.color] || 'black'
    const leading = leadings[content.data.leading] || ''
    const maxWidth = maxWidths[content.data.maxWidth || ''] || ''
    return `${fontSize} ${fontWeight} ${textAlign} ${color} ${leading} ${maxWidth}`
  }, [content.data])

  const margin = useMargin(content)

  return (
    <CText
      tag={content.data.level}
      override
      className={`${textClasses} ${margin}`}
    >
      {content.data.text}
    </CText>
  )
}
